"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const trash = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-trash` : '') + (description ? ` desc-trash` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-trash"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-trash"
  }, description), /*#__PURE__*/_react.default.createElement("g", {
    clipPath: "url(#clip0_972_2179)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M14.25 0.75C15.491 0.75 16.5 1.759 16.5 3V3.75H22.5C22.914 3.75 23.25 4.086 23.25 4.5C23.25 4.914 22.914 5.25 22.5 5.25H20.94L19.612 21.187C19.516 22.344 18.531 23.25 17.37 23.25H6.631C5.47 23.25 4.485 22.344 4.389 21.186L3.06 5.25H1.5C1.086 5.25 0.75 4.914 0.75 4.5C0.75 4.086 1.086 3.75 1.5 3.75H7.5V3C7.5 1.759 8.509 0.75 9.75 0.75H14.25ZM19.435 5.25H4.565L5.883 21.062C5.915 21.448 6.243 21.75 6.631 21.75H17.37C17.757 21.75 18.086 21.448 18.117 21.062L19.435 5.25ZM9.75 9C10.164 9 10.5 9.336 10.5 9.75V17.25C10.5 17.664 10.164 18 9.75 18C9.336 18 9 17.664 9 17.25V9.75C9 9.336 9.336 9 9.75 9ZM14.25 9C14.664 9 15 9.336 15 9.75V17.25C15 17.664 14.664 18 14.25 18C13.836 18 13.5 17.664 13.5 17.25V9.75C13.5 9.336 13.836 9 14.25 9ZM14.25 2.25H9.75C9.336 2.25 9 2.586 9 3V3.75H15V3C15 2.586 14.664 2.25 14.25 2.25Z",
    fill: "inherit"
  })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
    id: "clip0_972_2179"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    width: "24",
    height: "24",
    fill: "white"
  }))));
};
var _default = exports.default = trash;